import React, { useState } from "react";
import { Avatar, IconButton, Popover, Typography, Box } from "@mui/material";
import { FaUser } from "react-icons/fa";
import { Link } from "react-router-dom";
import PersonOutlineSharpIcon from "@mui/icons-material/PersonOutlineSharp";
import BorderColorSharpIcon from "@mui/icons-material/BorderColorSharp";
import LogoutSharpIcon from "@mui/icons-material/LogoutSharp";
import { IoMdCheckmarkCircle } from "react-icons/io";
import user from "../../assets/user22.jpg";
import useAuth from "../../hooks/useAuth";

function UserProfileAvatar() {
	const [anchorEl, setAnchorEl] = useState(null);
	const { auth } = useAuth();
	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const open = Boolean(anchorEl);

	// Sample user data
	const userData = {
		name: auth?.fullName,
		email: auth?.email,
		role: "Administrator",
	};

	return (
		<div>
			{/* Avatar Button */}
			<IconButton onClick={handleClick}>
				<Avatar alt={userData.name} src={user} />
			</IconButton>

			{/* Popover with user info */}
			<Popover
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "right",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "right",
				}}>
				<Box sx={{ p: 2, maxWidth: 300 }}>
					<div className="   flex  justify-center items-center gap-[0.8rem]  mb-[1.8rem] ">
						<div className="  w-[2.5rem]  h-[2.5rem] grid place-content-center  rounded-full  bg-[#E5CCF5]">
							{/* <FaUser className="" /> */}
							<img src={user} alt="user" className="rounded-full" />
						</div>
						<div>
							<h5>
								{auth?.fullName}{" "}
								<IoMdCheckmarkCircle className="  inline-block     text-green-500" />
							</h5>
							<p className="text-gray-500  text-[0.9rem]  tracking-wide   ">
								{auth?.email} <br />
								{/* <MdWavingHand className="inline-block text-[#E4914E]" /> */}
							</p>
						</div>
					</div>
					{/* <Typography gutterBottom variant="body2">
						<Link className="text-gray-500">
							{" "}
							<PersonOutlineSharpIcon
								sx={{ color: "gray", width: "0.9rem", mr: "0.3rem" }}
							/>{" "}
							View Profile
						</Link>
					</Typography> */}
					<Typography gutterBottom variant="body2" color="textSecondary">
						<Link to="/dctdashboard/admin/admin-setting">
							{" "}
							<BorderColorSharpIcon
								sx={{ color: "gray", width: "0.9rem", mr: "0.3rem" }}
							/>{" "}
							Edit Profile
						</Link>
					</Typography>
					<Typography variant="body2" color="textSecondary">
						<Link to="/" className="text-red-500">
							{" "}
							<LogoutSharpIcon
								sx={{ color: "#F95939", width: "0.9rem", mr: "0.3rem" }}
							/>{" "}
							Logout
						</Link>
					</Typography>
				</Box>
			</Popover>
		</div>
	);
}

export default UserProfileAvatar;
